package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.AddButtonIconStyle
import io.horion.cv.styles.AddButtonStyle
import io.horion.cv.styles.AddButtonTextStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun AddButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val borderColor = if (isDark) Colors.Placeholder else Colors.LightGray
    val textColor   = if (isDark) Colors.White       else Colors.Primary
    val iconFilter  = if (isDark) "none"             else "invert(0.4)"

    Row(
        modifier = AddButtonStyle.toModifier()
            .border(1.px, LineStyle.Solid, borderColor)
            .borderRadius(6.px)
            .cursor(Cursor.Pointer)
            .onClick { onClick() }
            .then(modifier),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(5.px)
    ) {
        FaPlus(
            modifier = AddButtonIconStyle.toModifier()
                .color(Color.rgb(0xb5, 0xb5, 0xb5))
                .styleModifier {
                    property("filter", iconFilter)
                }
        )
        SpanText(
            text = text,
            modifier = AddButtonTextStyle.toModifier()
                .color(textColor)
                .fontFamily(INTER)
        )
    }
}